import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ChannelsWeHandle } from '../components/ChannelsWeHandle';
import { ArrowRight, Check, ChevronRight, Star, Shield, Clock, Zap, Users, Bot, GitMerge, BarChart2 } from 'lucide-react';
export const Features = () => {
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-314">
      <Navbar data-id="element-315" />
      <main data-id="element-316">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-24 lg:py-32" data-id="element-317">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.05)_0,_transparent_70%)]" data-id="element-318"></div>
          <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-319"></div>
          {/* Decorative elements */}
          <div className="absolute top-20 left-10 w-64 h-64 bg-white/5 rounded-full filter blur-3xl" data-id="element-320"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-zinc-800/20 rounded-full filter blur-3xl" data-id="element-321"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-322">
            <div className="max-w-4xl mx-auto text-center" data-id="element-323">
              <div className="inline-block px-4 py-1 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 mb-6" data-id="element-324">
                <span className="font-['Playfair_Display'] text-zinc-400 text-sm tracking-wider" data-id="element-325">
                  COMPREHENSIVE CAPABILITIES
                </span>
              </div>
              <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl font-light mb-8 leading-tight" data-id="element-326">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-zinc-400" data-id="element-327">
                  Features
                </span>
              </h1>
              <p className="font-['Playfair_Display'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-328">
                Discover how our AI solution enhances your existing intake
                process and transforms how your law firm connects with potential
                clients.
              </p>
            </div>
          </div>
        </section>
        {/* Channels We Handle Section */}
        <ChannelsWeHandle data-id="element-329" />
        {/* Main Content */}
        <section className="relative py-20" data-id="element-330">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.02)_0,_transparent_50%)]" data-id="element-331"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-332">
            <div className="max-w-4xl mx-auto" data-id="element-333">
              {/* Complete Intake Team Section */}
              <div className="mb-32 relative" data-id="element-334">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-335"></div>
                <div className="flex items-center mb-6" data-id="element-336">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-337">
                    <Users size={24} className="text-white" data-id="element-338" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-339">
                    Enhance Your Intake Process with{' '}
                    <span className="text-white" data-id="element-340">AI Assistance</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-341">
                  <p className="font-['Playfair_Display'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-342">
                    Our AI solution works alongside your existing intake team,
                    providing immediate response capabilities that ensure 100%
                    of leads receive personalized attention—24/7, in any
                    language, regardless of whether intake is handled in-house
                    or by a call center.
                  </p>
                  <p className="font-['Playfair_Display'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-343">
                    Your practice can engage every prospect with prompt,
                    consistent service while your human team focuses on
                    high-value activities and complex client needs.
                  </p>
                  <div className="grid md:grid-cols-2 gap-6 mt-10" data-id="element-344">
                    <div className="bg-gradient-to-br from-zinc-900/80 to-black/80 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center" data-id="element-345">
                      <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-346">
                        <Users size={28} className="text-white" data-id="element-347" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-348">
                        Human Touch
                      </h3>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-349">
                        Seamlessly integrates with your existing team
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/80 to-black/80 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center" data-id="element-350">
                      <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-351">
                        <Bot size={28} className="text-white" data-id="element-352" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-xl mb-3" data-id="element-353">
                        AI Precision
                      </h3>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-354">
                        Instant responses with consistent quality
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Multi-Channel Coverage Section */}
              <div className="mb-32 relative" data-id="element-355">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-356"></div>
                <div className="flex items-center mb-6" data-id="element-357">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-358">
                    <GitMerge size={24} className="text-white" data-id="element-359" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-360">
                    Multi-Channel Coverage with{' '}
                    <span className="text-white" data-id="element-361">Seamless Handoff</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-362">
                  <p className="font-['Playfair_Display'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-363">
                    We handle the channels you already use—and uniquely allow
                    handoff between AI and people so no lead is ever missed.
                  </p>
                  <div className="relative" data-id="element-364">
                    <div className="absolute -inset-1 bg-gradient-to-r from-white/10 via-white/5 to-transparent rounded-sm blur" data-id="element-365"></div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm mb-8 relative" data-id="element-366">
                      <div className="absolute top-0 right-0 bg-white/5 px-3 py-1 text-xs text-zinc-400 rounded-bl-sm" data-id="element-367">
                        PHONE
                      </div>
                      <h3 className="font-['Playfair_Display'] text-2xl mb-6 flex items-center" data-id="element-368">
                        <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 text-white" data-id="element-369">
                          1
                        </span>
                        Inbound Calls
                      </h3>
                      <ul className="space-y-4 font-['Space_Grotesk'] text-zinc-300" data-id="element-370">
                        <li className="flex items-start" data-id="element-371">
                          <span className="mr-3 mt-1 text-white" data-id="element-372">
                            <Check size={18} data-id="element-373" />
                          </span>
                          <span className="leading-relaxed font-['Playfair_Display']" data-id="element-374">
                            Rings humans first
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-375">
                          <span className="mr-3 mt-1 text-white" data-id="element-376">
                            <Check size={18} data-id="element-377" />
                          </span>
                          <span className="leading-relaxed font-['Playfair_Display']" data-id="element-378">
                            If no pickup within 4 rings, AI picks up
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-379">
                          <span className="mr-3 mt-1 text-white" data-id="element-380">
                            <Check size={18} data-id="element-381" />
                          </span>
                          <span className="leading-relaxed font-['Playfair_Display']" data-id="element-382">
                            Nights, weekends, and foreign-language calls are
                            routed to appropriate party
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-383">
                          <span className="mr-3 mt-1 text-white" data-id="element-384">
                            <Check size={18} data-id="element-385" />
                          </span>
                          <span className="leading-relaxed font-['Playfair_Display']" data-id="element-386">
                            Live transfers call to human when requested or
                            urgent
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="relative" data-id="element-387">
                    <div className="absolute -inset-1 bg-gradient-to-r from-white/10 via-white/5 to-transparent rounded-sm blur" data-id="element-388"></div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm relative" data-id="element-389">
                      <div className="absolute top-0 right-0 bg-white/5 px-3 py-1 text-xs text-zinc-400 rounded-bl-sm" data-id="element-390">
                        DIGITAL
                      </div>
                      <h3 className="font-['Playfair_Display'] text-2xl mb-6 flex items-center" data-id="element-391">
                        <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 text-white" data-id="element-392">
                          2
                        </span>
                        Website Leads & Messages
                      </h3>
                      <ul className="space-y-4 font-['Space_Grotesk'] text-zinc-300" data-id="element-393">
                        <li className="flex items-start" data-id="element-394">
                          <span className="mr-3 mt-1 text-white" data-id="element-395">
                            <Check size={18} data-id="element-396" />
                          </span>
                          <span className="leading-relaxed font-['Playfair_Display']" data-id="element-397">
                            AI answers first within seconds
                          </span>
                        </li>
                        <li className="flex items-start" data-id="element-398">
                          <span className="mr-3 mt-1 text-white" data-id="element-399">
                            <Check size={18} data-id="element-400" />
                          </span>
                          <span className="leading-relaxed font-['Playfair_Display']" data-id="element-401">
                            Humans are instantly notified to follow up if needed
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* Every Conversation Section */}
              <div className="mb-32 relative" data-id="element-402">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-403"></div>
                <div className="flex items-center mb-6" data-id="element-404">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-405">
                    <Shield size={24} className="text-white" data-id="element-406" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-407">
                    The Only Legal Intake Service Where{' '}
                    <span className="text-white" data-id="element-408">Every Conversation Is</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-409">
                  <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-410">
                    <ul className="space-y-6 font-['Space_Grotesk'] text-zinc-200 text-lg" data-id="element-411">
                      <li className="flex items-start" data-id="element-412">
                        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-413">
                          <Check size={20} className="text-white" data-id="element-414" />
                        </div>
                        <div data-id="element-415">
                          <h4 className="text-white mb-1 font-medium" data-id="element-416">
                            Handled by AI or a Human
                          </h4>
                          <p className="text-zinc-400" data-id="element-417">
                            Depending on availability and preference
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-418">
                        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-419">
                          <Check size={20} className="text-white" data-id="element-420" />
                        </div>
                        <div data-id="element-421">
                          <h4 className="text-white mb-1 font-medium" data-id="element-422">
                            Visible to Both AI and Humans
                          </h4>
                          <p className="text-zinc-400" data-id="element-423">
                            So nothing slips through the cracks
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-424">
                        <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 mt-1 flex-shrink-0" data-id="element-425">
                          <Check size={20} className="text-white" data-id="element-426" />
                        </div>
                        <div data-id="element-427">
                          <h4 className="text-white mb-1 font-medium" data-id="element-428">
                            Tracked, Audited, and Analyzed
                          </h4>
                          <p className="text-zinc-400" data-id="element-429">
                            For continuous improvement
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* What AI Handles Section */}
              <div className="mb-32 relative" data-id="element-430">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-431"></div>
                <div className="flex items-center mb-6" data-id="element-432">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-433">
                    <Bot size={24} className="text-white" data-id="element-434" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-435">
                    What AI{' '}
                    <span className="text-white" data-id="element-436">Handles Instantly</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-437">
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-8 leading-relaxed" data-id="element-438">
                    Our AI is trained on legal intake best practices and
                    responds in under 5 seconds. It can:
                  </p>
                  <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-439">
                    <div className="grid md:grid-cols-2 gap-8" data-id="element-440">
                      <div className="space-y-6 font-['Space_Grotesk'] text-zinc-300" data-id="element-441">
                        <div className="flex items-start" data-id="element-442">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-443">
                            <Check size={16} className="text-white" data-id="element-444" />
                          </div>
                          <span className="leading-relaxed" data-id="element-445">
                            Answer first calls or messages
                          </span>
                        </div>
                        <div className="flex items-start" data-id="element-446">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-447">
                            <Check size={16} className="text-white" data-id="element-448" />
                          </div>
                          <span className="leading-relaxed" data-id="element-449">
                            Introduce your firm and provide helpful answers
                          </span>
                        </div>
                        <div className="flex items-start" data-id="element-450">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-451">
                            <Check size={16} className="text-white" data-id="element-452" />
                          </div>
                          <div data-id="element-453">
                            <p className="leading-relaxed" data-id="element-454">
                              Qualify leads based on:
                            </p>
                            <ul className="pl-4 mt-3 space-y-3" data-id="element-455">
                              <li className="flex items-center" data-id="element-456">
                                <ChevronRight size={14} className="text-zinc-500 mr-2" data-id="element-457" />
                                Practice state(s)
                              </li>
                              <li className="flex items-center" data-id="element-458">
                                <ChevronRight size={14} className="text-zinc-500 mr-2" data-id="element-459" />
                                Case alignment with firm specialties
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-6 font-['Space_Grotesk'] text-zinc-300" data-id="element-460">
                        <div className="flex items-start" data-id="element-461">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-462">
                            <Check size={16} className="text-white" data-id="element-463" />
                          </div>
                          <div data-id="element-464">
                            <p className="leading-relaxed" data-id="element-465">
                              Collect essential details:
                            </p>
                            <ul className="pl-4 mt-3 space-y-3" data-id="element-466">
                              <li className="flex items-center" data-id="element-467">
                                <ChevronRight size={14} className="text-zinc-500 mr-2" data-id="element-468" />
                                Name
                              </li>
                              <li className="flex items-center" data-id="element-469">
                                <ChevronRight size={14} className="text-zinc-500 mr-2" data-id="element-470" />
                                Email
                              </li>
                              <li className="flex items-center" data-id="element-471">
                                <ChevronRight size={14} className="text-zinc-500 mr-2" data-id="element-472" />
                                Phone
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-473">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-474">
                            <Check size={16} className="text-white" data-id="element-475" />
                          </div>
                          <span className="leading-relaxed" data-id="element-476">
                            If qualified: book an appointment or send a retainer
                            agreement
                          </span>
                        </div>
                        <div className="flex items-start" data-id="element-477">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-478">
                            <Check size={16} className="text-white" data-id="element-479" />
                          </div>
                          <span className="leading-relaxed" data-id="element-480">
                            If not: provide alternatives or referrals
                          </span>
                        </div>
                        <div className="flex items-start" data-id="element-481">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-482">
                            <Check size={16} className="text-white" data-id="element-483" />
                          </div>
                          <span className="leading-relaxed" data-id="element-484">
                            Notify staff immediately via email
                          </span>
                        </div>
                        <div className="flex items-start" data-id="element-485">
                          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-3 flex-shrink-0 mt-1" data-id="element-486">
                            <Check size={16} className="text-white" data-id="element-487" />
                          </div>
                          <span className="leading-relaxed" data-id="element-488">
                            <span className="bg-white/10 px-2 py-0.5 text-xs rounded" data-id="element-489">
                              PREMIUM
                            </span>{' '}
                            Enter data directly into your practice management
                            system
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Premium Optimization Section */}
              <div className="mb-32 relative" data-id="element-490">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-491"></div>
                <div className="flex items-center mb-6" data-id="element-492">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-493">
                    <BarChart2 size={24} className="text-white" data-id="element-494" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-495">
                    Premium Optimization:{' '}
                    <span className="text-white" data-id="element-496">No More Guesswork</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-497">
                  <div className="relative mb-8" data-id="element-498">
                    <div className="absolute -inset-1 bg-gradient-to-r from-white/20 via-white/10 to-transparent rounded-sm blur" data-id="element-499"></div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm relative" data-id="element-500">
                      <div className="absolute top-0 right-0 bg-white/10 px-3 py-1 text-xs text-white rounded-bl-sm font-medium" data-id="element-501">
                        PREMIUM
                      </div>
                      <p className="font-['Space_Grotesk'] text-zinc-200 text-lg mb-8 leading-relaxed" data-id="element-502">
                        With LexSquire Premium, you don't have to choose between
                        human or AI. We automatically:
                      </p>
                      <div className="space-y-6" data-id="element-503">
                        <div className="flex items-start" data-id="element-504">
                          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-505">
                            <Check size={20} className="text-white" data-id="element-506" />
                          </div>
                          <div data-id="element-507">
                            <h4 className="text-white mb-1 font-medium" data-id="element-508">
                              Split-test AI vs. human intake
                            </h4>
                            <p className="text-zinc-400 text-sm" data-id="element-509">
                              Compare performance across all your channels
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-510">
                          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-511">
                            <Check size={20} className="text-white" data-id="element-512" />
                          </div>
                          <div data-id="element-513">
                            <h4 className="text-white mb-1 font-medium" data-id="element-514">
                              Score conversations
                            </h4>
                            <p className="text-zinc-400 text-sm" data-id="element-515">
                              Based on engagement and conversion metrics
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-516">
                          <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-517">
                            <Check size={20} className="text-white" data-id="element-518" />
                          </div>
                          <div data-id="element-519">
                            <h4 className="text-white mb-1 font-medium" data-id="element-520">
                              Default to the best option
                            </h4>
                            <p className="text-zinc-400 text-sm" data-id="element-521">
                              For your specific audience, removing uncertainty
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-522">
                    <p className="font-['Space_Grotesk'] text-zinc-300 text-lg leading-relaxed" data-id="element-523">
                      Millennials and younger clients often prefer AI, while
                      older demographics may lean toward human interaction. We
                      let the data decide—so you don't have to.
                    </p>
                  </div>
                </div>
              </div>
              {/* Smarter AI Section */}
              <div className="mb-32 relative" data-id="element-524">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-525"></div>
                <div className="flex items-center mb-6" data-id="element-526">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-527">
                    <Zap size={24} className="text-white" data-id="element-528" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-529">
                    Smarter AI,{' '}
                    <span className="text-white" data-id="element-530">Effortless Setup</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-531">
                  <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-532">
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-533">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-534">
                        <Clock size={24} className="text-white" data-id="element-535" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-lg mb-3" data-id="element-536">
                        No Training Required
                      </h3>
                      <p className="font-['Space_Grotesk'] text-zinc-400 text-sm" data-id="element-537">
                        During your initial call, we set up your AI
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-538">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-539">
                        <GitMerge size={24} className="text-white" data-id="element-540" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-lg mb-3" data-id="element-541">
                        Continuous Learning
                      </h3>
                      <p className="font-['Space_Grotesk'] text-zinc-400 text-sm" data-id="element-542">
                        Every human conversation feeds back into the system
                      </p>
                    </div>
                    <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-6 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-543">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-4" data-id="element-544">
                        <Zap size={24} className="text-white" data-id="element-545" />
                      </div>
                      <h3 className="font-['Playfair_Display'] text-lg mb-3" data-id="element-546">
                        Progressive Improvement
                      </h3>
                      <p className="font-['Space_Grotesk'] text-zinc-400 text-sm" data-id="element-547">
                        Your AI becomes smarter and more aligned with your
                        practice
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Final CTA Section */}
              <div className="relative mb-20" data-id="element-548">
                <div className="absolute inset-0 bg-gradient-to-r from-zinc-900/50 via-zinc-800/50 to-zinc-900/50 rounded-sm blur" data-id="element-549"></div>
                <div className="relative bg-gradient-to-br from-zinc-900 to-zinc-800 p-10 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-550">
                  <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-551">
                    <div className="mb-6 md:mb-0 md:mr-8" data-id="element-552">
                      <h3 className="font-['Playfair_Display'] text-2xl mb-4 font-light" data-id="element-553">
                        With LexSquire, you don't just get intake coverage
                      </h3>
                      <p className="font-['Space_Grotesk'] text-white text-lg" data-id="element-554">
                        You get a squire dedicated to your firm, ensuring every
                        lead is engaged, qualified, and moved forward.
                      </p>
                    </div>
                    <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-8 py-4 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center whitespace-nowrap" data-id="element-555">
                      Schedule a Demo
                      <ArrowRight size={18} className="ml-2" data-id="element-556" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-557" />
    </div>;
};